export enum StockErrorTypes {
  INIT_PAYMENT = 'initPayment',
}
